(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('HospitalizationTypeParent', HospitalizationTypeParent);

    HospitalizationTypeParent.$inject = ['$resource'];

    function HospitalizationTypeParent ($resource) {
        var resourceUrl =  'api/hospitalization-type-parents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
